import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://prestijcrm.duckdns.org';

const DURUM = {
  onay_bekliyor: ['Onay bekliyor', '#fef3c7', '#b45309'],
  kuyrukta: ['Sırada', '#e0e7ff', '#4338ca'],
  gonderiliyor: ['Gönderiliyor', '#e0e7ff', '#4338ca'],
  gonderildi: ['Gönderildi', '#dbeafe', '#1d4ed8'],
  teslim: ['Teslim edildi', '#dcfce7', '#15803d'],
  okundu: ['Okundu', '#bbf7d0', '#166534'],
  hata: ['Hata', '#fee2e2', '#b91c1c'],
  iptal: ['İptal', '#f1f5f9', '#64748b'],
};

const card = { background: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: 20, marginBottom: 16 };
const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' };
const lbl = { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 };
const btn = (bg, fg = '#fff') => ({ background: bg, color: fg, border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600 });
const tarih = (t) => (t ? new Date(t).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');

export default function Messages() {
  const headers = { Authorization: 'Bearer ' + localStorage.getItem('token') };
  const [sekme, setSekme] = useState('gonder');
  const [durum, setDurum] = useState(null);
  const [sablonlar, setSablonlar] = useState([]);
  const [kuyruk, setKuyruk] = useState([]);
  const [gelen, setGelen] = useState([]);
  const [engel, setEngel] = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [filtre, setFiltre] = useState('');
  const [secili, setSecili] = useState([]);
  const [secKuyruk, setSecKuyruk] = useState([]);
  const [form, setForm] = useState({ sablon: '', dil: 'tr', govde: '', parametreler: [], manuel: '' });
  const [mesaj, setMesaj] = useState('');
  const [yanit, setYanit] = useState({});

  const yukle = useCallback(async () => {
    const g = (u) => axios.get(API + u, { headers }).then((r) => r.data).catch((e) => ({ error: e.response?.data?.error || e.message }));
    const [d, s, k, ge, en, m] = await Promise.all([g('/api/whatsapp/durum'), g('/api/whatsapp/sablonlar'), g('/api/whatsapp/kuyruk'), g('/api/whatsapp/gelen'), g('/api/whatsapp/engel'), g('/api/customers')]);
    setDurum(d); setSablonlar(s.sablonlar || []); setKuyruk(k.kuyruk || []); setGelen(ge.gelen || []); setEngel(en.engel || []);
    setMusteriler(m.customers || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { yukle(); const t = setInterval(yukle, 30000); return () => clearInterval(t); }, [yukle]);

  const sablonSec = (ad) => {
    const s = sablonlar.find((x) => x.ad === ad);
    const govde = s ? s.govde : form.govde;
    const n = (govde.match(/\{\{\d+\}\}/g) || []).length;
    setForm((f) => ({ ...f, sablon: ad, dil: s ? s.dil : f.dil, govde, parametreler: Array.from({ length: n }, (_, i) => f.parametreler[i] || (i === 0 ? '{ad}' : '')) }));
  };

  const onizleme = form.govde.replace(/\{\{(\d+)\}\}/g, (m, i) => (form.parametreler[i - 1] || m).replace(/\{ad\}/g, 'Ahmet Bey'));

  const kuyrugaEkle = async () => {
    const alicilar = musteriler.filter((m) => secili.includes(m.id)).map((m) => ({ telefon: m.whatsapp_number || m.phone, ad: m.name, kaynak: 'musteri', kaynak_id: m.id }));
    form.manuel.split('\n').map((l) => l.trim()).filter(Boolean).forEach((l) => {
      const parca = l.split(/[;,\t|]/); const tel = parca.find((p) => /\d{7,}/.test(p.replace(/\D/g, ''))) || l;
      const ad = parca.filter((p) => p !== tel).join(' ').trim();
      alicilar.push({ telefon: tel, ad, kaynak: 'manuel' });
    });
    if (!form.sablon) return setMesaj('Önce bir şablon seçin.');
    if (!alicilar.length) return setMesaj('En az bir alıcı seçin veya numara yazın.');
    try {
      const r = await axios.post(API + '/api/whatsapp/kuyruk', { alicilar, sablon: form.sablon, dil: form.dil, parametreler: form.parametreler, govde: form.govde }, { headers });
      setMesaj(`${r.data.eklendi} mesaj onay listesine eklendi.` + (r.data.atlandi.length ? ` Atlanan ${r.data.atlandi.length}: ` + r.data.atlandi.map((a) => `${a.ad || a.telefon} (${a.sebep})`).join(', ') : ''));
      setSecili([]); setForm((f) => ({ ...f, manuel: '' })); setSekme('kuyruk'); yukle();
    } catch (e) { setMesaj('Hata: ' + (e.response?.data?.error || e.message)); }
  };

  const kuyrukIslem = async (islem, ids) => {
    if (!ids.length) return;
    await axios.post(API + '/api/whatsapp/kuyruk/' + islem, { ids }, { headers });
    setSecKuyruk([]); yukle();
  };

  const yanitGonder = async (tel) => {
    try { await axios.post(API + '/api/whatsapp/yanitla', { telefon: tel, metin: yanit[tel] }, { headers }); setYanit((y) => ({ ...y, [tel]: '' })); yukle(); }
    catch (e) { alert(e.response?.data?.error || e.message); }
  };

  const engelle = async (tel) => { await axios.post(API + '/api/whatsapp/engel', { telefon: tel }, { headers }); yukle(); };

  const bagli = durum?.yapilandirildi && !durum?.numara_hata;
  const onayBekleyen = kuyruk.filter((k) => k.durum === 'onay_bekliyor');
  const mFiltre = musteriler.filter((m) => !filtre || (m.name + ' ' + (m.phone || '') + ' ' + (m.district || '') + ' ' + (m.bolgeler || []).join(' ')).toLowerCase().includes(filtre.toLowerCase()));

  return (
    <div style={{ padding: 24, fontFamily: 'Inter,sans-serif', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1e293b' }}>WhatsApp Otomatik Mesaj</h1>
          <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 14 }}>Resmi WhatsApp Business API — onayladığınız mesajlar mesai saatinde, aralıklı ve günlük limitle otomatik gider; cevaplar burada toplanır.</p>
        </div>
        <span style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 700, background: bagli ? '#dcfce7' : '#fee2e2', color: bagli ? '#15803d' : '#b91c1c' }}>
          {bagli ? `● Bağlı: ${durum.numara?.display_phone_number || ''} ${durum.numara?.verified_name ? '· ' + durum.numara.verified_name : ''}` : '● WhatsApp API bağlı değil'}
        </span>
      </div>

      {durum && !bagli && (
        <div style={{ ...card, border: '1px solid #fecaca', background: '#fff7f7' }}>
          <b style={{ color: '#b91c1c' }}>Gönderim için kurulumun bitmesi gerekiyor</b>
          {durum.numara_hata && <div style={{ fontSize: 13, color: '#b91c1c', marginTop: 6 }}>Meta cevabı: {durum.numara_hata}</div>}
          <ol style={{ fontSize: 14, color: '#374151', margin: '10px 0 0', paddingLeft: 20, lineHeight: 1.7 }}>
            <li>Meta Business Suite → Ayarlar → İşletme bilgileri → <b>İşletme doğrulaması</b> (vergi levhası vb.).</li>
            <li>WhatsApp Yöneticisi → Telefon numaraları → <b>+90 551 541 62 72 → Kaydet (Register)</b>, SMS kodu + 6 haneli PIN.</li>
            <li>Kalıcı erişim anahtarı (System User token) oluşturup sunucuya eklemek — bu adımı Claude ile birlikte yapacaksınız.</li>
            <li>Mesaj şablonunu WhatsApp Yöneticisi'nde oluşturup Meta onayını beklemek (genelde dakikalar–birkaç saat).</li>
          </ol>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 8 }}>Bu arada alıcı listesi hazırlayıp onay listesine ekleyebilirsiniz; bağlantı kurulunca onayladıklarınız otomatik gider.</div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['Bugün gönderilen', `${durum?.bugun ?? 0} / ${durum?.gunluk_limit ?? 50}`], ['Onay bekleyen', durum?.sayilar?.onay_bekliyor || 0], ['Sırada', durum?.sayilar?.kuyrukta || 0], ['Okunan', durum?.sayilar?.okundu || 0], ['Hata', durum?.sayilar?.hata || 0], ['Okunmamış cevap', durum?.okunmamis || 0]].map(([t, v]) => (
          <div key={t} style={{ ...card, marginBottom: 0, padding: '12px 16px', flex: '1 1 140px' }}><div style={{ fontSize: 12, color: '#64748b' }}>{t}</div><div style={{ fontSize: 22, fontWeight: 700, color: '#1e293b' }}>{v}</div></div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['gonder', 'Yeni gönderim'], ['kuyruk', `Onay & gönderim listesi (${onayBekleyen.length})`], ['gelen', `Gelen cevaplar (${durum?.okunmamis || 0})`], ['engel', 'Mesaj istemeyenler']].map(([k, t]) => (
          <button key={k} onClick={() => { setSekme(k); if (k === 'gelen') axios.post(API + '/api/whatsapp/gelen/okundu', {}, { headers }).then(yukle); }} style={btn(sekme === k ? '#1e293b' : '#e2e8f0', sekme === k ? '#fff' : '#334155')}>{t}</button>
        ))}
      </div>
      {mesaj && <div style={{ ...card, padding: 12, background: '#eff6ff', color: '#1e3a8a', fontSize: 14 }}>{mesaj} <button onClick={() => setMesaj('')} style={{ ...btn('transparent', '#1e3a8a'), padding: '0 6px' }}>×</button></div>}

      {sekme === 'gonder' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(340px,1fr))', gap: 16 }}>
          <div style={card}>
            <h3 style={{ marginTop: 0 }}>1. Şablon</h3>
            <label style={lbl}>Onaylı şablon</label>
            {sablonlar.length ? (
              <select value={form.sablon} onChange={(e) => sablonSec(e.target.value)} style={{ ...inp, marginBottom: 10 }}>
                <option value="">Seçin…</option>
                {sablonlar.map((s) => <option key={s.ad + s.dil} value={s.ad} disabled={s.durum !== 'APPROVED'}>{s.ad} ({s.dil}) {s.durum !== 'APPROVED' ? '— ' + s.durum : ''}</option>)}
              </select>
            ) : (
              <>
                <input value={form.sablon} onChange={(e) => setForm((f) => ({ ...f, sablon: e.target.value.trim() }))} placeholder="örn: pelit_arsa_tanitim" style={{ ...inp, marginBottom: 6 }} />
                <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>API bağlanınca onaylı şablonlar burada listelenecek.</div>
                <label style={lbl}>Şablon metni (önizleme için, {'{{1}}'} = 1. değişken)</label>
                <textarea value={form.govde} onChange={(e) => { const g = e.target.value; const n = (g.match(/\{\{\d+\}\}/g) || []).length; setForm((f) => ({ ...f, govde: g, parametreler: Array.from({ length: n }, (_, i) => f.parametreler[i] || (i === 0 ? '{ad}' : '')) })); }} style={{ ...inp, height: 110, marginBottom: 10 }} />
              </>
            )}
            {form.parametreler.map((p, i) => (
              <div key={i} style={{ marginBottom: 8 }}>
                <label style={lbl}>Değişken {'{{' + (i + 1) + '}}'} <span style={{ fontWeight: 400, color: '#94a3b8' }}>({'{ad}'} yazarsanız kişinin adı gelir)</span></label>
                <input value={p} onChange={(e) => setForm((f) => { const ps = [...f.parametreler]; ps[i] = e.target.value; return { ...f, parametreler: ps }; })} style={inp} />
              </div>
            ))}
            {form.govde && <div style={{ background: '#e7fbe9', borderRadius: 8, padding: 12, fontSize: 13, whiteSpace: 'pre-wrap', marginTop: 8 }}>{onizleme}</div>}
          </div>

          <div style={card}>
            <h3 style={{ marginTop: 0 }}>2. Alıcılar</h3>
            <label style={lbl}>CRM müşterileri ({secili.length} seçili)</label>
            <input value={filtre} onChange={(e) => setFiltre(e.target.value)} placeholder="İsim, telefon, bölge ara…" style={{ ...inp, marginBottom: 6 }} />
            <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
              <button onClick={() => setSecili([...new Set([...secili, ...mFiltre.map((m) => m.id)])])} style={btn('#e2e8f0', '#334155')}>Listeleneni seç</button>
              <button onClick={() => setSecili([])} style={btn('#e2e8f0', '#334155')}>Temizle</button>
            </div>
            <div style={{ maxHeight: 220, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6, marginBottom: 12 }}>
              {mFiltre.map((m) => (
                <label key={m.id} style={{ display: 'flex', gap: 8, padding: '6px 10px', fontSize: 13, borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}>
                  <input type="checkbox" checked={secili.includes(m.id)} onChange={(e) => setSecili(e.target.checked ? [...secili, m.id] : secili.filter((x) => x !== m.id))} />
                  <span style={{ flex: 1 }}>{m.name}</span><span style={{ color: '#64748b' }}>{m.whatsapp_number || m.phone}</span>
                </label>
              ))}
              {!mFiltre.length && <div style={{ padding: 10, fontSize: 13, color: '#94a3b8' }}>Müşteri yok</div>}
            </div>
            <label style={lbl}>Elle numara ekle (her satıra bir kişi: Ad; Telefon)</label>
            <textarea value={form.manuel} onChange={(e) => setForm((f) => ({ ...f, manuel: e.target.value }))} placeholder={'Güralp Yapı; 0532 689 73 10\nKALİÇ İnşaat; 0532 668 89 85'} style={{ ...inp, height: 100, marginBottom: 12 }} />
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>Sabit hat / 0850 numaraları, mesaj istemeyenler ve son 30 günde aynı şablonu almış kişiler otomatik atlanır.</div>
            <button onClick={kuyrugaEkle} style={{ ...btn('#16a34a'), width: '100%', padding: 12 }}>Onay listesine ekle</button>
          </div>
        </div>
      )}

      {sekme === 'kuyruk' && (
        <div style={card}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
            <button onClick={() => kuyrukIslem('onayla', onayBekleyen.map((k) => k.id))} style={btn('#16a34a')}>Bekleyenlerin hepsini onayla ({onayBekleyen.length})</button>
            <button onClick={() => kuyrukIslem('onayla', secKuyruk)} style={btn('#22c55e')}>Seçilenleri onayla</button>
            <button onClick={() => kuyrukIslem('iptal', secKuyruk)} style={btn('#ef4444')}>Seçilenleri iptal et</button>
            <span style={{ fontSize: 12, color: '#64748b' }}>Onaylananlar {durum?.saat} arası, {durum?.aralik_sn} sn arayla, günde en fazla {durum?.gunluk_limit} mesaj gider.</span>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ background: '#f8fafc', textAlign: 'left' }}><th style={{ padding: 8 }}></th><th>Kişi</th><th>Telefon</th><th>Şablon</th><th>Durum</th><th>Zaman</th><th>Not</th></tr></thead>
              <tbody>
                {kuyruk.map((k) => { const [t, bg, fg] = DURUM[k.durum] || [k.durum, '#eee', '#333']; return (
                  <tr key={k.id} style={{ borderTop: '1px solid #f1f5f9' }} title={k.metin || ''}>
                    <td style={{ padding: 8 }}><input type="checkbox" checked={secKuyruk.includes(k.id)} onChange={(e) => setSecKuyruk(e.target.checked ? [...secKuyruk, k.id] : secKuyruk.filter((x) => x !== k.id))} /></td>
                    <td>{k.ad || '-'}</td><td>+{k.telefon}</td><td>{k.sablon}</td>
                    <td><span style={{ padding: '2px 8px', borderRadius: 12, background: bg, color: fg, fontWeight: 600, fontSize: 12 }}>{t}</span></td>
                    <td>{tarih(k.durum_zamani || k.gonderim_zamani || k.olusturma)}</td>
                    <td style={{ color: '#b91c1c', maxWidth: 280 }}>{k.hata}</td>
                  </tr>); })}
                {!kuyruk.length && <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: '#94a3b8' }}>Liste boş</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {sekme === 'gelen' && (
        <div style={card}>
          {!gelen.length && <div style={{ color: '#94a3b8', textAlign: 'center', padding: 20 }}>Henüz gelen cevap yok</div>}
          {gelen.map((g) => (
            <div key={g.id} style={{ borderBottom: '1px solid #f1f5f9', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <b>{g.kayitli_ad || g.ad || 'Bilinmeyen'} <span style={{ fontWeight: 400, color: '#64748b' }}>+{g.telefon}</span></b>
                <span style={{ color: '#94a3b8' }}>{tarih(g.zaman)}</span>
              </div>
              <div style={{ background: '#f1f5f9', borderRadius: 8, padding: '8px 12px', margin: '6px 0', fontSize: 14, whiteSpace: 'pre-wrap' }}>{g.metin}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <input value={yanit[g.telefon] || ''} onChange={(e) => setYanit((y) => ({ ...y, [g.telefon]: e.target.value }))} placeholder="Yanıt yazın (24 saat içinde serbest yazılabilir)" style={inp} />
                <button onClick={() => yanitGonder(g.telefon)} style={btn('#16a34a')}>Gönder</button>
                <a href={'https://wa.me/' + g.telefon} target="_blank" rel="noreferrer" style={{ ...btn('#e2e8f0', '#334155'), textDecoration: 'none' }}>Telefondan</a>
                <button onClick={() => engelle(g.telefon)} style={btn('#fee2e2', '#b91c1c')}>Bir daha yazma</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {sekme === 'engel' && (
        <div style={card}>
          <p style={{ fontSize: 13, color: '#64748b', marginTop: 0 }}>"DUR", "İPTAL", "istemiyorum" diye cevap verenler otomatik eklenir; bu kişilere bir daha toplu mesaj gitmez.</p>
          {engel.map((e) => (
            <div key={e.telefon} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f1f5f9', fontSize: 13 }}>
              <span>+{e.telefon} — {e.sebep}</span>
              <button onClick={() => axios.delete(API + '/api/whatsapp/engel/' + e.telefon, { headers }).then(yukle)} style={btn('#e2e8f0', '#334155')}>Kaldır</button>
            </div>
          ))}
          {!engel.length && <div style={{ color: '#94a3b8' }}>Liste boş</div>}
        </div>
      )}
    </div>
  );
}
